var map = {
	"./battery.svg": "4b7d",
	"./beanpod.svg": "dea1",
	"./dna.svg": "4de5",
	"./map.svg": "9b8a",
	"./nucleus_blue.svg": "a635",
	"./nucleus_purple.svg": "3d09",
	"./stars.svg": "c2ba",
	"./sun.svg": "af3b",
	"./turtle.svg": "981a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c9b3";